import {
    PocComponentHeader,
    PocProgressSpinner,
    PocStepper,
    PocTypography,
} from 'commons/components/components-wrapper';
import { t } from 'core/i18n/i18n';
import { TooltipedIconComponent } from '../tooltiped-icon';
import { WorkflowOverlayWithStepperLayout } from './workflow-overlay.style';

interface WorkflowOverlayWithStepperComponentProps extends React.PropsWithChildren {
    visible: boolean;
    steps: React.ReactNode;
    activeStep: number;
    loading?: boolean;
    headerTitle: string | React.ReactElement;
    footer?: React.ReactElement[];
    disableEscape?: boolean;
    onClose: VoidFunction;
}

export const WorkflowOverlayWithStepperComponent: React.FC<WorkflowOverlayWithStepperComponentProps> = (props) => {
    const {
        children,
        steps,
        activeStep,
        visible,
        loading = false,
        headerTitle,
        footer,
        disableEscape = true,
        onClose,
    } = props;

    return (
        <WorkflowOverlayWithStepperLayout
            visible={visible}
            closeIconProps={{ onclick: onClose }}
            noCloseIcon
            noAutoFocus
            disableEscapeKeydown={disableEscape}
            data-testid="workflow-overlay"
        >
            <PocComponentHeader>
                <TooltipedIconComponent
                    slot="prefix"
                    icon={'clear'}
                    tooltipText={t('commons.components.icon.close.tooltip')}
                    onClick={onClose}
                />
                <PocTypography>{headerTitle}</PocTypography>
            </PocComponentHeader>
            <div slot="content" className={loading ? 'loading' : ''}>
                <PocStepper activeStep={activeStep} linear>
                    {steps}
                </PocStepper>
                {loading ? <PocProgressSpinner variant="primary" size="large" /> : children}
            </div>
            {footer ? <div slot="footer">{footer}</div> : undefined}
        </WorkflowOverlayWithStepperLayout>
    );
};
